// Configurations
import Axios from 'config/service.config'
import env from 'config/env_config'

export const savePetLocally = petData => {
  const pets = JSON.parse(window.sessionStorage.getItem('pets')) || []
  const pet = {
    ...petData,
    id: pets.length,
    breed: {
      id: petData.breed,
      type: petData.petType
    }
  }

  delete pet.petType

  const petExists = pets.some(savedPet => {
    return (savedPet.name === pet.name && savedPet.breed.id === pet.breed.id)
  })

  if (!petExists) {
    pets.push(pet)
    window.sessionStorage.setItem('pets', JSON.stringify(pets))
    return true
  }

  return false
}

export const getPetsLocally = () => {
  const pets = JSON.parse(window.sessionStorage.getItem('pets')) || []
  return pets
}

export const getPetByIdLocally = id => {
  const pets = getPetsLocally()
  return pets[id]
}

export const updatePetLocally = petData => {
  const pets = getPetsLocally()
  const pet = {
    ...petData,
    breed: {
      id: petData.breed,
      type: petData.petType
    }
  }
  delete pet.petType
  pets[petData.id] = pet
  window.sessionStorage.setItem('pets', JSON.stringify(pets))
}

export const clearPetsLocally = () => {
  window.sessionStorage.removeItem('pets')
}

export const deletePet = async (id) => {
  try {
    const response = await Axios({ baseURL: env.pet, url: '/pets/'.concat(id) })
    if (response === undefined || response === null) return
    const data = response.data || null
    return data
  } catch (error) {
  }
}

export const getBreeds = async (id, headers) => {
  try {
    const response = await Axios({ baseURL: env.pet, url: '/breeds/type/'.concat(id), withCredentials: true, headers })
    if (response === undefined || response === null) return
    const data = response.data || null
    return data
  } catch (error) {
  }
}

export const getPetById = async (id, headers) => {
  try {
    const response = await Axios({ baseURL: env.pet, url: '/pets/'.concat(id), withCredentials: true, headers })
    if (response === undefined || response === null) return
    const data = response.data || null
    return data
  } catch (error) {
  }
}

export const insertPet = async (bodyPets) => {
  const response = await Axios({ method: 'post', baseURL: env.pet, url: '/pets', data: bodyPets, withCredentials: true })
  if (response === undefined || response === null) return
  const data = response.data || null
  return data
}

export const updatePet = async (bodyPets) => {
  const response = await Axios({ method: 'put', baseURL: env.pet, url: '/pets/'.concat(bodyPets.id), data: bodyPets, withCredentials: true })
  if (response === undefined || response === null) return
  const data = response.data || null
  return data
}

export const batchCreateOrEditPet = async pets => {
  const { data: results } = await Axios({
    method: 'put',
    baseURL: env.pet,
    url: '/pets/batch',
    data: pets,
    withCredentials: true
  })
  return results
}
